<template>
	<div>
		<headerNav title="产品列表" />
        <div class="content" v-if="backColor" :style="backColor?'background-color:'+backColor:''">
            <div class="curmain" :style="backColor?'background-color:'+backColor:''">
                
            </div>
            <div class="main-pic">
                <img v-if="contentPath||picPath" :src="contentPath?$baseurl+contentPath:$baseurl+picPath"/>
            </div>
            <div class="goods-list">
				<van-list
					v-model="isLoading"
					:finished="loadingType=='nomore'?true:false"
					:finished-text="loadingType=='nomore'?'没有更多了':'下拉加载更多'"
					@load="onRefresh"
				>
				<div v-if="goodlist.length>0">
					<div class="goods-item" v-for="(item, index) in goodlist" @click="navtodetail(item)" :key="index">
                        <div class="image-wrapper" >
                            <img  :src="$baseurl+item.productImageUrl">
                        </div>
						<div class="wz">
							<span class="title">{{item.pName}}</span>
							<div v-if="item.isSeaProduct" :style="{color:$abctheme.basecolor}" class="stitle">
								【海外产品】
							</div>
							<div class="price-box">
								<span class="price">{{item.userPrice}}</span>
								<span v-if="item.realSaleNum">已售{{item.realSaleNum}}</span>
							</div>
						</div>
                        
                    </div>
				</div>	 
				</van-list>
            </div>
	    </div>
    </div>
	
</template>
<script>
	export default {
			data() {
				return {
					requestparams:
					{
					  headNavDetailId:0,
					  sorting: " sorter desc",
					  maxResultCount: 4,
					  skipCount: 0,
                    },
                    isLoading:false,
					totalcount:0,
					goodlist: [],
					loadingType: 'more',
					hidepull:false,
					backColor:'',
					contentPath:'',
					picPath:''
				}
			},
            created()
            {
                var options = this.$route.query;
                this.requestparams.headNavDetailInfoId = options.id;
                this.loadparentdata();
				
            },
			methods: {
				loadparentdata()
				{
					this.ajax.post('/api/services/app/PhoneCom/QueryHeadNavDetailInfo',this.requestparams).then(x=>{
						let HeadNavInfo=x.result;
						this.backColor=HeadNavInfo.backColor;
						this.picPath=HeadNavInfo.picPath;
						this.contentPath=HeadNavInfo.contentPath;
					})
                },
                onRefresh()
                {
                    this.loadData();
				},
				navtodetail(item){
					var productSku = item.productSku;
					this.$router.push({path:'/product/'+productSku});
				},
                loadData(source)
                {
					
                    if (
                        this.loadingType === "loading" ||
                        this.loadingType === "nomore"
                    ) {
                        //防止重复加载
                        if(source!="refresh")
                        {
                        return;
                        }
                    }
                    if (source == "refresh"||this.loadingType=='refresh') {
                        this.goodlist = [];
                        this.requestparams.skipCount = 0;
                    }
                    this.loadingType = "loading";
                    //分页获取
                    this.ajax.post("/api/services/app/PhoneCom/QueryHeaNavDetail", this.requestparams).then((x) => {
                    
                    this.requestparams.skipCount+=this.requestparams.maxResultCount;
                    var  goods = x.result.items;
                    this.goodlist=this.goodlist.concat(goods);
                    let totalcount = x.result.totalCount;
                    this.loadingType =totalcount > this.requestparams.skipCount? "more": "nomore";
                    //console.log(this.goodlist);
                    
                    }).finally(()=>
                    {
                        this.isLoading=false;
                    });
                },
			},
		}
</script>
<style lang="scss" scoped>
	
	/* 商品列表 */
	.content{
		width: 100%;
	}
	.curmain
	{
		position: absolute;
		top:0;
		bottom: 0;
		left: 0;
		right: 0;
		z-index: -999;
	}
	.main-pic
	{
		width: 350px;
		margin: auto;
		padding-top: 20px;
		padding-bottom: 20px;
	}
	.main-pic img{
		width: 100%;
		border-radius: 6px;
	}
	.goods-list {
		display: flex;
		flex-wrap: wrap;
		padding: 0 15px;
		.goods-item {
			display: inline-block;
			flex-direction: column;
			width: 45%;
			padding-bottom: 20px;
			background-color: #ffffff;
			margin-bottom: 20px;
			border-radius: 7px;
			padding: 5px;
			
			&:nth-child(2n) {
				float: right;
			}
		}
	
		.image-wrapper {
			width: 100%;
			height: 165px;
			border-radius: 3px;
			overflow: hidden;
	
			img {
				width: 100%;
				height: 100%;
				opacity: 1;
			}
		}
		.wz{
			position: relative;
		}
		.title {
			font-size: 14px;
			color:#303133;
			line-height: 15px;
			word-break: break-all;
			text-overflow: ellipsis;
			-webkit-line-clamp: 2;
			overflow: hidden;
			-webkit-box-orient: vertical;
			display: -webkit-box;
			margin-bottom: 2px;
			min-height: 30px;
		}
		.stitle
		{
			font-size: 14px;
			margin-bottom: 3px;
		}
	
		.price-box {
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding-right: 5px;
			font-size: 12px;
			color: #f8f6fc;
		}
	
		.price {
			font-size:16px;
			color: #fa436a;
			line-height: 1;
	
			&:before {
				content: '￥';
				font-size: 26upx;
			}
		}
	}
</style>